module.exports = __webpack_public_path__ + "static/media/OQ.bf0f4c5f.png";